import styled from 'styled-components';

const Text = styled.div`
    font-size: 12px;
    text-align: center;
`;

export default Text;
